module.exports = __webpack_public_path__ + "static/man-39c5e66774d35c48d9e17ac97b4ba48d.png";